import { takeLatest, call, put, all } from "redux-saga/effects";
import { getSupportItemOrList } from "@services/api";
import { GET_SUPPORT_CONFIGS } from "../reducers/actionTypes";
import { actions } from "../reducers/supportReducer";

function* getSetSupportConfigsTickets(params) {
  const { id } = params || {};
  try {
    const payload = {
      type: "LIST",
      id: id || "CL_MAIN_LIST_V3",
      item_id: params && params.item_id ? params.item_id : "",
    };
    const { data } = yield call(getSupportItemOrList, payload);
    yield put(actions.setSupportConfigs(data));
  } catch (error) {
    console.log(error);
  }
}
export default function* root() {
  yield all([takeLatest(GET_SUPPORT_CONFIGS, getSetSupportConfigsTickets)]);
}
